import React, { PureComponent } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import container from './container'
import { ReusableButton, media, TimeInput, Switch } from 'gipsy-ui'
import { constants, styles, translations, utils } from 'gipsy-misc'
import { Header, SectionContainer } from 'pages/settings/components/common'

const propTypes = {
  weeklyWorkingHours: PropTypes.object,
  isSaved: PropTypes.bool,
  areWeeklyWorkingHoursRepeated: PropTypes.bool,
  toggleWorkingDay: PropTypes.func.isRequired,
  onChangeWorkHours: PropTypes.func.isRequired,
  onChangeRepeat: PropTypes.func.isRequired,
  firstActiveDayWorkingHours: PropTypes.object /* { workStart (DateTimeString), workEnd (DateTimeString) } */
}

export class WorkingHours extends PureComponent {
  renderTimeInput = (paramName, workingHour) => {
    const { onChangeWorkHours } = this.props
    return (
      <TimeInputContainer>
        <TimeInput
          showPeriod={true}
          format="12h"
          hour={workingHour.workStart.hour}
          minute={workingHour.workStart.minute}
          paramName={paramName}
          onChange={onChangeWorkHours.bind(null, 'workStart')}
        />
        <ToContainer>{translations.general.to.toLowerCase()}</ToContainer>
        <TimeInput
          showPeriod={true}
          format="12h"
          hour={workingHour.workEnd.hour}
          minute={workingHour.workEnd.minute}
          paramName={paramName}
          onChange={onChangeWorkHours.bind(null, 'workEnd')}
        />
      </TimeInputContainer>
    )
  }
  render() {
    const {
      weeklyWorkingHours,
      areWeeklyWorkingHoursRepeated,
      onChangeRepeat,
      toggleWorkingDay,
      saved,
      firstActiveDayWorkingHours
    } = this.props

    return weeklyWorkingHours ? (
      <SectionContainer>
        <Header title={translations.settings.section.workingHours.title} isSaved={saved} />
        <DaysOfWeekContainer>
          <DaysOfWeekLabelContainer>{translations.settings.section.workingHours.label}</DaysOfWeekLabelContainer>
          <ListContainer>
            {constants.weekdays.map(day => (
              <DayButton
                key={day}
                height={32}
                width={64}
                fontSize={12}
                borderRadius={4}
                textColor={weeklyWorkingHours[day].active ? 'white' : styles.colors.textLightColor}
                backgroundColor={weeklyWorkingHours[day].active ? styles.colors.greenColor : styles.colors.lightGrey}
                onClick={() => toggleWorkingDay({ day })}>
                {utils.string.capitalize(translations.days.shortLabel[day])}
              </DayButton>
            ))}
          </ListContainer>
        </DaysOfWeekContainer>
        <div>
          <HoursRepeatContainer className="hours-repeat">
            <SwitchContainer>
              <Switch paramName="all" onChange={onChangeRepeat} value={areWeeklyWorkingHoursRepeated} />
              <SwitchLabelContainer>
                {translations.settings.section.workingHours.repeatHoursLabel}{' '}
                {areWeeklyWorkingHoursRepeated && translations.general.from.toLowerCase()}
              </SwitchLabelContainer>
            </SwitchContainer>
            {areWeeklyWorkingHoursRepeated && this.renderTimeInput('all', firstActiveDayWorkingHours)}
          </HoursRepeatContainer>
          {!areWeeklyWorkingHoursRepeated &&
            constants.weekdays.map(day => {
              return (
                weeklyWorkingHours[day].active && (
                  <DayLineContainer key={day}>
                    <DayLineLabelContainer>
                      {translations.general.on.toLowerCase()} {utils.string.capitalize(translations.days.label[day])}{' '}
                      {translations.general.from.toLowerCase()}
                    </DayLineLabelContainer>
                    {this.renderTimeInput(day, weeklyWorkingHours[day])}
                  </DayLineContainer>
                )
              )
            })}
        </div>
      </SectionContainer>
    ) : null
  }
}

export const DayButton = styled(ReusableButton)`
  padding: 6px 10px;
  &:hover {
    background-color: ${styles.colors.greenColor};
    .button-label {
      color: white;
    }
  }
`

const DaysOfWeekContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 24px;

  ${media['phone-wide']`
      flex-direction: column;
      align-items: baseline;
`}
`

const DaysOfWeekLabelContainer = styled.div`
  margin-right: 20px;
`

const ListContainer = styled.div`
  &&&&& {
    display: flex;
    align-items: center;
    ${media['phone-wide']`
      width: 100%;
      margin: 0px;
      margin-top: 8px;
      justify-content:space-between;
`}
    button {
      margin-left: 6px;
      ${media['phone-wide']`
      margin-left:0px;
      min-width: 13%;
      width: auto;
      padding: 1px 1px;
`}
    }
    button:first-child {
      margin-left: 0px;
    }
  }
`

const HoursRepeatContainer = styled.div`
  display: flex;
  margin-bottom: 24px;
  line-height: 40px;
  align-items: center;
  ${media['phone-wide']`
    flex-direction:column;
    align-items: baseline;
    margin-bottom:10px;
  `}
`

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  .switch {
    margin-right: 16px;
  }
  ${media['phone-wide']`
    margin-bottom:10px;
  `}
`

const SwitchLabelContainer = styled.span`
  margin-right: 20px;
`

const TimeInputContainer = styled.div`
  &&& {
    display: flex;
    align-items: center;
    .time-input {
      margin-right: 10px;
    }
    .time-input .time input,
    .time-input .period input {
      padding: 12px 0px;
      &:hover,
      &.focus {
        background-color: transparent;
      }
    }
    .time-input .time {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    .time-input .period {
      margin-left: 0;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      input {
        text-align: left;
      }
    }
  }
`

const ToContainer = styled.span`
  margin-right: 10px;
`

const DayLineContainer = styled.div`
  &&& {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    ${media['phone-wide']`
      flex-direction: column;
      align-items: baseline;
    `}
  }
`

const DayLineLabelContainer = styled.span`
  min-width: 200px;
  ${media['phone-wide']`
      margin-bottom: 10px
    `}
`

WorkingHours.propTypes = propTypes

export default container(WorkingHours)



// WEBPACK FOOTER //
// ./src/pages/settings/components/workinghours/index.js